import React, { FC } from "react";

import { useAuthContext } from "../../../../../auth";
import { PersonalAreaAuthenticated } from "./personal-area-authenticated";
import { PersonalAreaUnauthenticated } from "./personal-area-unauthenticated";

export interface PersonalAreaSpecialItemProps {}

export const PersonalAreaSpecialItem: FC<PersonalAreaSpecialItemProps> = () => {
  const { logged } = useAuthContext();
  return logged ? <PersonalAreaAuthenticated /> : <PersonalAreaUnauthenticated />;
};
